import { StyledTitle, measures, text } from "@quickpoint.me/shared";

import ToggleFilesPanelButton from "../ToggleFilesPanel";
import { UnprocessedIds } from "../../state/uploaderState";
import UploadFileView from "./UploadFileView";
import styled from "styled-components";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";

const StyledUploadFilesView = styled.div<{ $isInPortrait: boolean }>`
    grid-area: tabs / browse;
    display: grid;
    grid-template-columns: ${(props) => (props.$isInPortrait ? "repeat(1, 1fr)" : "1fr 1fr")};
    grid-gap: ${(props) =>
			props.$isInPortrait
				? measures.dialogPanel.portrait.margin
				: measures.dialogPanel.landscape.margin};
    padding: ${(props) =>
			props.$isInPortrait
				? measures.dialogPanel.portrait.margin
				: measures.dialogPanel.landscape.margin};
`;

function UploadFilesView({ $isInPortrait }: { $isInPortrait: boolean }) {
	const unprocessedIds = useRecoilValue(UnprocessedIds);
	const files = unprocessedIds.map((id) => (
		<UploadFileView key={id} fileID={id} $isInPortrait={$isInPortrait} />
	));
	const showTitle = unprocessedIds.length > 0;

	useEffect(() => {
		// animate scrolling the panel to the top
		const panel = document.getElementById("file-uploader");
		if (panel) {
			panel.scrollTo({ top: 0, behavior: "smooth" });
		}
	}, []);

	return (
		<>
			{showTitle && (
				<StyledTitle $isInPortrait={$isInPortrait} className="title">
					<div role="heading" aria-level={2}>{text.fileUploader.uploadTitle}</div>
					<ToggleFilesPanelButton />
				</StyledTitle>
			)}
			<StyledUploadFilesView $isInPortrait={$isInPortrait}>
				{files}
			</StyledUploadFilesView>
		</>
	);
}

export default UploadFilesView;
